var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('br'), _vm._v(" "), _c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('legend', [_vm._v("RVP Print Label")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Scan Flyer Barcode")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-barcode'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.barCode),
      expression: "barCode"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('barcode')
    },
    attrs: {
      "name": "barcode"
    },
    domProps: {
      "value": (_vm.barCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.barCode = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.barCodeErrorMSG) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.barCodeErrorMSG))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b-form-fieldset', [_c('label', [_c('br')]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showdeatils()
      }
    }
  }, [_c('span'), _vm._v("Show Shipment Label")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetData()
      }
    }
  }, [_c('span'), _vm._v("Reset")]), _vm._v("  \n                "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.singlePrint == false
    },
    on: {
      "click": function($event) {
        return _vm.printLineHaul()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print Shipment Label")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.showTable == true) ? _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment ID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Shipment Status ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Last Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentTableData), function(data) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.AWBNumber))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.LastModifiedDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "btn btn-success",
      staticStyle: {
        "font-size": "13px"
      },
      on: {
        "click": function($event) {
          return _vm.RVPForShippingID(data)
        }
      }
    }, [_vm._v("Print")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-card', [(_vm.tripdatafound == true) ? _c('div', {
    attrs: {
      "id": "tripsheetContent"
    }
  }, [_vm._l((_vm.shipmentData), function(data, i, index) {
    return [_c('table', {
      staticClass: "border",
      attrs: {
        "align": "right",
        "width": "100%"
      }
    }, [_c('table', {
      staticClass: "vertical-th",
      attrs: {
        "align": "left",
        "width": "15%"
      }
    }, [_c('label', [_c('strong', {
      staticStyle: {
        "font-size": "10px"
      }
    }), _c('VueBarcode', {
      attrs: {
        "value": data.AWBNO,
        "height": "35"
      }
    })], 1)]), _vm._v(" "), _c('table', {
      attrs: {
        "align": "right",
        "width": "55%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "17px"
      }
    }, [_vm._v("DTO")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "10px"
      }
    }, [_c('VueBarcode', {
      attrs: {
        "value": data.AWBNO,
        "height": "35"
      }
    })], 1)])])])]), _vm._v(" "), _c('table', {
      attrs: {
        "align": "right",
        "width": "55%"
      }
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("Client Name: ")]), _vm._v("\n                          " + _vm._s(data.ClientName))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("Delivery Address : ")]), _vm._v(_vm._s(data.DeliveryAddress))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Pincode : ")]), _vm._v(" " + _vm._s(data.DeliveryPinCode) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("Vendor :")]), _vm._v(" " + _vm._s(data.Vendor) + " ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "12px"
      }
    }, [_vm._v("DTO Branch :")]), _vm._v(" " + _vm._s(data.DTOBranch))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("E-Way Bill No : ")]), _vm._v("\n                          " + _vm._s(data.EWayBillNo))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [_vm._v("Pick Up Details :")])])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("Pickup Date: ")]), _vm._v(" " + _vm._s(data.PickupDate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("Pickup Center ")]), _vm._v(" " + _vm._s(data.PickUpHub))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v("Picked By : ")]), _vm._v(" " + _vm._s(data.PickedBy) + " ")])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "colspan": "3"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "13px"
      }
    }, [_vm._v(" Remarks : ")]), _vm._v(" " + _vm._s(data.Remarks))])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "text",
      attrs: {
        "colspan": "5"
      }
    }, [_c('strong', {
      staticStyle: {
        "font-size": "7px"
      }
    }, [_vm._v("THIS PRODUCT IS BEING RETURNED TO THE SELLER / WAREHOUSE DUE TO DAMAGE / DEFECTIVE OR NOT\n                                MEETING CUSTOMERS REQUIREMENT")])])])])])])]
  })], 2) : _vm._e()])], 1)])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67b174d9","hasScoped":true}!./src/views/components/RVPLabel/RVPLabel.html
// module id = 1217
// module chunks = 2